import { string } from 'yup'
import { safify } from '../utils/safify'

export const videoLength = string().meta({ label: 'How long should the video be?', autoFill: true }).transform(safify)
